import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, ProgressBar } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveInvitationInfo, DriveUIActionTypes, ProcessingType, NodePermissionLabels, buildNavigationLink, DriveEntryType, useAppSelector } from "src/common";
import { Icon } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  invitation: DriveInvitationInfo;
  responding: boolean;
  handleAction: ActionHandlerFunction;
};

function InvitationsRowComponent(props: AllProps) {
  const { invitation, responding, handleAction } = props;
  const navigate = useNavigate();
  const processing = invitation.processing === ProcessingType.accepting || invitation.processing === ProcessingType.rejecting;
  const root_info = useAppSelector((state: RootState) => state.drive.root_info);
  const allow_sync = invitation.sync_by_default && !!invitation.global_local_sync;

  // Description: Render an Accept/Reject button that dispatches RespondToShareInvitation with the chosen response
  function respondButton(accept: boolean) {
    const button_text = accept ? "Accept" : "Reject";
    return <Button
      variant={accept ? "outline-secondary" : "no-outline-secondary"}
      size="sm"
      onClick={() => {
        handleAction({
          actionType: DriveUIActionTypes.RespondToShareInvitation,
          params: {
            invitation, accept,
            sync: invitation.permissions_label === NodePermissionLabels.view_only ? false : allow_sync
          },
        });
      }}>
      {button_text}
    </Button>;
  }

  // Description: When an invitation row is clicked (if it is accepted and has a link_id), navigate to the link in my preveil.
  function handleNameClick() {
    if (invitation.processing === ProcessingType.accepted && !!root_info && !!invitation.link_id) {
      const url = buildNavigationLink(root_info?.collection_id, invitation.link_id, DriveEntryType.LINK);
      navigate(url);
    }
  }

  return (
    <Row className={`${invitation.processing !== ProcessingType.accepted ? "not-accepted" : ""}`} onClick={handleNameClick}>
      <Col md="3" className="entry-name">
        <span>
          <Icon className="fsi-shared" />{invitation.name}
        </span>
      </Col>
      <Col md="3" className="overflow-text">{invitation.sharer_user_id}</Col>
      <Col md="2" className="overflow-text">{invitation.permissions_label}</Col>
      <Col className="text-start overflow-text d-md-none d-lg-block">{invitation.expiration.split(" ")[0]}</Col>
      <Col md="auto" className="btn-panel">
        {
          invitation.processing === ProcessingType.accepted ?
            <span className="light-blue-text me-2">Accepted</span> :
            <>
              {
                processing && responding ?
                  <ProgressBar
                    variant="secondary"
                    animated
                    now={50}
                    label={`${50}% completed`}
                    visuallyHidden /> :
                  <>
                    {respondButton(true)}
                    {respondButton(false)}
                  </>
              }
            </>
        }
      </Col>
    </Row>
  );
}

export default React.memo(InvitationsRowComponent);
